import React from 'react'
import TestItemAudioControls from './TestItemAudioControls'
import TestAudioControls from './TestAudioControls'

const AudioControls = ({ isTestSettings, ...props }) => {
  return isTestSettings ? (
    <TestAudioControls {...props} />
  ) : (
    <TestItemAudioControls {...props} />
  )
}

export default AudioControls
